module.exports = __webpack_public_path__ + "static/media/calendar-question.e3de0bf3.svg";